module.exports = __webpack_public_path__ + "static/media/grafitiTime.24f5fc00.png";